import { create } from "zustand";

export interface EventStore {
  questions: any;
  setQuestions: (args: any) => void;
  tickets: any;
  setTickets: (args: any) => void;
  gradientColors: any;
  setGradientColors: (args: any) => void;
  previewMode: boolean;
  setPreviewMode: (previewMode: boolean) => void;
  eventData: any;
  setEventData: (args: any) => void;
  userAccess: string;
  setUserAccess: (args: any) => void;
  addedQuestion: string[];
  setAddedQuestion: (addedQuestion: string[]) => void;
  // for refetching question, for mobile version showing counys besided QnA
  refetchQnAStatus: boolean;
  setRefetchQnAStatus: (refetchQnAStatus: boolean) => void;
  //  for question answer modal - replace it
  qnAQuestionId: string;
  setQnAQuestionId: (qnAQuestionId: string) => void;
  showNewQueIndicator?: boolean;
  setShowNewQueIndicator: (showNewQueIndicator: boolean) => void;
  showRefreshIndicator?: boolean;
  setShowRefreshIndicator: (showRefreshIndicator: boolean) => void;
}

export const useEventStore = create<EventStore>((set) => ({
  questions: [],
  setQuestions: (questions: any) => set({ questions }),
  tickets: [],
  setTickets: (tickets: any) => set({ tickets }),
  gradientColors: {},
  setAddedQuestion: (addedQuestion: string[]) => set({ addedQuestion }),
  setGradientColors: (gradientColors: any) => set({ gradientColors }),
  addedQuestion: [],
  previewMode: false,
  setPreviewMode: (previewMode: boolean) => set({ previewMode }),
  eventData: {},
  setEventData: (eventData: any) => set({ eventData }),
  userAccess: "",
  setUserAccess: (userAccess: string) => set({ userAccess }),
  refetchQnAStatus: false,
  setRefetchQnAStatus: (refetchQnAStatus: boolean) => set({ refetchQnAStatus }),
  qnAQuestionId: "",
  setQnAQuestionId: (qnAQuestionId: string) => set({ qnAQuestionId }),
  showNewQueIndicator: false,
  setShowNewQueIndicator: (showNewQueIndicator: boolean) => set({ showNewQueIndicator }),
  showRefreshIndicator: false,
  setShowRefreshIndicator: (showRefreshIndicator: boolean) => set({ showRefreshIndicator })
}));
